import { motion } from "framer-motion";
import { STAGES } from "../lib/content";

export const StageTracker = ({ stage = 2, className = "" }) => (
  <div
    className={`grid overflow-hidden rounded-2xl border border-border bg-card md:grid-cols-3 ${className}`}
    data-testid="stage-tracker"
  >
    {STAGES.map((s, i) => {
      const n = i + 1;
      const underway = n <= stage;
      const now = n === stage;
      return (
        <div
          key={n}
          data-testid={`stage-tracker-step-${n}`}
          className={`relative flex min-w-0 flex-col gap-3 p-6 sm:p-7 ${
            now ? "bg-primary/[0.06]" : ""
          } ${i < 2 ? "border-border max-md:border-b md:border-r" : ""}`}
        >
          {now && (
            <motion.span
              layoutId="tracker-topline"
              className="absolute inset-x-0 top-0 h-[4px] bg-terra"
              transition={{ type: "spring", stiffness: 120, damping: 20 }}
            />
          )}
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span className="font-mono text-[0.7rem] tracking-[0.18em] text-muted-foreground">
              STAGE {n} OF 3
            </span>
            <span className={`pill ${underway ? "pill-on" : "pill-wait"}`}>
              {underway ? "Underway" : "Not yet open"}
            </span>
          </div>
          <h3 className="font-display text-lg font-bold leading-snug">
            {s.name}
          </h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {s.detail}
          </p>
        </div>
      );
    })}
  </div>
);
